import { OptimizationSettings, Schedule, ScheduleItem } from "../../../models";
import { getScheduleItem } from "./getScheduleItem";

const parseOptimizationSettings = (
  apiSettings: any
): OptimizationSettings | undefined => {
  if (!apiSettings) return undefined;

  return {
    storageYardIds: apiSettings.storage_yard_ids || [],
    startingDumpsterSize: apiSettings.starting_dumpster_size || undefined,
    startingDumpsterFull: apiSettings.starting_dumpster_full ?? undefined,
  };
};

export const getSchedule = (data: any, included: any): Schedule => {
  const items: ScheduleItem[] = (included || []).map(getScheduleItem);

  let scheduleItems: ScheduleItem[] = [];
  if (!!data.relationships && !!data.relationships["schedule_items"]) {
    scheduleItems = data.relationships["schedule_items"].data.map(
      (si: { type: string; id: string }) => {
        return items.find((s) => s.id === si.id);
      }
    );
  }
  scheduleItems.sort((a, b) => a.orderNumber - b.orderNumber);

  return {
    id: data.id,
    driverId: data.attributes.driver_id,
    vehicleId: data.attributes.vehicle_id,
    date: data.attributes.date,
    isOptimizing: data.attributes.is_optimizing,
    optimizedTime: data.attributes.optimized_time,
    optimizedDistance: data.attributes.optimized_distance,
    optimizationSettings: parseOptimizationSettings(
      data.attributes.optimization_settings
    ),
    scheduleItems,
  };
};

export const getSchedules = (response: any): Schedule[] => {
  const schedules = response.data.map((s: any) => {
    const schedule = getSchedule(s, response.included);
    return schedule;
  });

  return schedules;
};
